import React, {Fragment, useEffect, useState, useContext} from 'react'
import farmerContext from '../../../context/farmer/farmerContext'
import {filter_options} from '../../../helpers/genericFunctions';
import {useAlert} from "react-alert";


const Profile = () => {

    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const FarmerContext = useContext(farmerContext);
    const {updateProfile, uploadImage, getStates, getLga, clearAlert, farmer} = FarmerContext;
    const alert = useAlert()
    const [user_data, setUser_data] = useState({
        farmStates: [],
        farmLgas: [],
        userInfo: JSON.parse(localStorage.getItem('userInfo')),

        //button loader for submit
        hide_spinner: "d-none",
        disable_button: false,

        //image
        userImage: JSON.parse(localStorage.getItem('userInfo')).passport,
        hide_spinner_image: "d-none",
        disable_button_image: false,

        //hide and show image form
        change_image_button: "d-inline",
        image_form_class: "d-none",

    })

    useEffect(() => {

        if (user_data.farmStates.length === 0) {
            getStates().then(state_res => {
                let states_data = JSON.parse(state_res.request.response).data;

                setUser_data(prevState => ({
                        ...prevState,
                        farmStates: states_data,
                    })
                )

                getLga(userInfo.state_id).then(lga_res => {
                    let lga_data = JSON.parse(lga_res.request.response).data;
                    setUser_data(prevState => ({
                            ...prevState,
                            farmLgas: lga_data,
                        })
                    )
                });
            });
        }

        //show image form
        let image_button = document.getElementById("change_image_button");
        image_button.addEventListener('click', show_image_form);

        //hide image form
        let cancel_image_change = document.getElementById("cancel_image_change");
        cancel_image_change.addEventListener('click', hide_image_form);

        if (farmer.message.msg !== "") {
            alert.show(
                farmer.message.msg, farmer.message.msg_options
            )
            clearAlert();
        }
    }, [farmer.message.msg]);

    const onSubmit = e => {

        e.preventDefault()
        //button loader for submit
        setUser_data(prevState => ({
                ...prevState,
                disable_button: true,
                hide_spinner: " d-inline-block"
            })
        )

        let edit_profile_form = document.getElementById("edit_profile_form");

        let updated_profile = new FormData(edit_profile_form);
        updateProfile(updated_profile).then(res => {

            if (parseInt(res.request.status) === 200) {
                //set new info to local storage
                localStorage.setItem('userInfo', JSON.stringify(res.data.data));
            }
            setUser_data(prevState => ({
                    ...prevState,
                    disable_button: false,
                    hide_spinner: " d-none"
                })
            )
        })
    }

    const update_image = e => {
        e.preventDefault()

        //button loader for submit
        setUser_data(prevState => ({
                ...prevState,
                disable_button_image: true,
                hide_spinner_image: "d-inline-block"
            })
        )

        let update_image = document.getElementById("update_image");
        let form = new FormData(update_image);

        uploadImage(form).then(res => {
            if (parseInt(res.request.status) === 200) {
                let new_image = JSON.parse(res.request.response).data.result[0];
                setUser_data(prevState => ({
                        ...prevState,
                        userImage: new_image,
                        hide_spinner_image: true
                    })
                )
                hide_image_form();
                update_image.reset();

                //persist to local store
                let updated_info = userInfo;
                updated_info.passport = new_image
                localStorage.setItem('userInfo', JSON.stringify(updated_info));

            }

            setUser_data(prevState => ({
                    ...prevState,
                    disable_button_image: false,
                    hide_spinner_image: "d-none"
                })
            )
        })
    }

    let show_image_form = () => {
        setUser_data(prevState => ({
                ...prevState,
                change_image_button: " d-none",
                image_form_class: " d-inline"
            })
        )
    }

    let get_lga = (state_id) => {
        getLga(state_id).then(lga_res => {
            let lga_data = JSON.parse(lga_res.request.response).data;
            setUser_data(prevState => ({
                    ...prevState,
                    farmLgas: lga_data,
                })
            )
        })
    }

    let hide_image_form = () => {
        setUser_data(prevState => ({
                ...prevState,
                change_image_button: " d-inline",
                image_form_class: " d-none"
            })
        )
    }


    return (
        <Fragment>
            <div className="content-wrapper">
                <div className="container-fluid">
                    <div className="dashboard-inner-view">
                        <div className="row mt-3 justify-content-center">
                            <div className="col-lg-10">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h3 className="make-bold">Profile Settings</h3>
                                        <p>Update your personal and business information</p>
                                    </div>
                                    <div className="col-lg-6 card">
                                        <div className="card-body">
                                            <form onSubmit={onSubmit} id="edit_profile_form">
                                                <div className="form-group mb-5">
                                                    <label>First Name <span className="text-danger">*</span></label>
                                                    <input type="text"
                                                           className="form-control form-control-custom-view"
                                                           name='first_name'
                                                           defaultValue={user_data.userInfo.first_name}
                                                           required/>
                                                </div>
                                                <div className="form-group mb-5">
                                                    <label>Last Name <span className="text-danger">*</span></label>
                                                    <input type="text"
                                                           className="form-control form-control-custom-view"
                                                           name='last_name'
                                                           defaultValue={user_data.userInfo.last_name}
                                                           required/>
                                                </div>
                                                <div className="form-group mb-5">
                                                    <label>Phone Number <span className="text-danger">*</span></label>
                                                    <input type="text"
                                                           className="form-control form-control-custom-view"
                                                           name='phone'
                                                           defaultValue={user_data.userInfo.phone} required/>
                                                </div>
                                                <div className="form-group mb-5">
                                                    <label>State <span className="text-danger">*</span></label>
                                                    <select className="form-control " name="state_id" id="state_id"
                                                            onChange={e => get_lga(e.target.value)}
                                                    >
                                                        {filter_options(user_data.farmStates, user_data.userInfo.state_id)}
                                                    </select>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>LGA <span className="text-danger">*</span></label>
                                                    <select className="form-control " name="lga_id" id="lga_id">
                                                        {filter_options(user_data.farmLgas, user_data.userInfo.lga_id)}
                                                    </select>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Address <span className="text-danger">*</span></label>
                                                    <textarea className="form-control form-control-custom-view"
                                                              rows="5"
                                                              name='address'
                                                              defaultValue={user_data.userInfo.address}>

                                                            </textarea>
                                                </div>
                                                <div className="form-row justify-content-center mb-5">

                                                    <button type="submit" className={"btn btn-orange btn-custom-view"}
                                                            disabled={user_data.disable_button}>
                                                        Update Profile
                                                        <i className="ml-1 fa fa-check" aria-hidden="true"> </i>
                                                        <span
                                                            className={"spinner-border spinner-border-sm ml-2 " + user_data.hide_spinner}
                                                            role="status"
                                                            aria-hidden="true">
                                                        </span>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="text-center mb-10 mb-lg-20">
                                                    <h4 className="make-bold mt-3">Profile Picture</h4>
                                                </div>

                                                <form
                                                    onSubmit={update_image}
                                                    id="update_image"
                                                    // onSubmit={handle_image_submit}
                                                    encType="multipart/form-data"
                                                >
                                                    <div className="form-group mt-5">
                                                        {/*<img src="https://hailing.s3.us-east-2.amazonaws.com/old-tractor.jpg"*/}
                                                        <img src={user_data.userImage}
                                                             className="rounded-circle img-fluid mx-auto d-block border"
                                                             style={{height: "200px", width: "200px"}}
                                                             alt="Equipment image"/>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className={"text-center p-t-15"}>
                                                            <div
                                                                className={"btn btn-orange btn-custom-view" + user_data.change_image_button}
                                                                id="change_image_button">
                                                                Change Image
                                                                <i className="ml-1 far fa-edit"
                                                                   aria-hidden="true"> </i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={user_data.image_form_class}>
                                                        <div className="form-group  mt-5">
                                                            <label className="font-weight-semibold">
                                                                New image
                                                            </label>
                                                            <input
                                                                type="file"
                                                                className="form-control form-control-solid h-auto py-5 px-6"
                                                                id="club_image"
                                                                name="passport"
                                                                required
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <div className="row text-center">
                                                                <div className="col-6">
                                                                    <button
                                                                        className="btn btn-rounded btn-danger"
                                                                        id="cancel_image_change">
                                                                        Cancel
                                                                        <i className="ml-1 fa fa-close"
                                                                           aria-hidden="true"> </i>
                                                                    </button>
                                                                </div>
                                                                <div className="col-6">
                                                                    <button
                                                                        className="btn btn-orange btn-custom-view"
                                                                        disabled={user_data.disable_button_image}>
                                                                        Save
                                                                        <i className="ml-1 fa fa-check"
                                                                           aria-hidden="true"> </i>
                                                                        <span
                                                                            className={"spinner-border spinner-border-sm ml-2 " + user_data.hide_spinner_image}
                                                                            role="status"
                                                                            aria-hidden="true">
                                                                                     </span>
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!--End Dashboard Content--> */}

                </div>
                {/* <!-- End container-fluid--> */}

            </div>
            {/* End wrapper */}

        </Fragment>
    )
}

export default Profile
